import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl-next';
import { ConfluenceIcon } from '@atlaskit/logo';
import { AdvancedSearchFooter } from '../../advanced-search-footer';
import { messages } from '../messages';
import { QuickFindAdvancedSearchLink } from './quick-find-footer.styled';
import { PersistRecentSearch } from '../../recent-searches/persist-recent-search';
export var FilterFooter = function FilterFooter() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var confluenceIcon = /*#__PURE__*/React.createElement(ConfluenceIcon, {
    appearance: "brand",
    size: "small"
  });
  return /*#__PURE__*/React.createElement(PersistRecentSearch, null, /*#__PURE__*/React.createElement(QuickFindAdvancedSearchLink, null, /*#__PURE__*/React.createElement(AdvancedSearchFooter, {
    squareReturnIcon: true,
    searchFooterLabel: formatMessage(messages.quick_find_show_filtered_results),
    searchFooterLabelWithIcon: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.quick_find_show_filtered_results_with_icon, {
      values: {
        confluenceIcon: confluenceIcon
      }
    })),
    filterByProductFooter: true
  })));
};